import React from 'react';
import { FiUploadCloud, FiLoader, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

function UploadField({ onFileSelect, status = 'idle', fileName = '', label = 'Upload a file' }) {
  const statusContent = {
    idle: (
      <>
        <SafeIcon icon={FiUploadCloud} className="mx-auto h-12 w-12 text-gray-400" />
        <div className="flex text-sm text-gray-600">
          <span className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none">
            <span>{label}</span>
          </span>
          <p className="pl-1">or drag and drop</p>
        </div>
        <p className="text-xs text-gray-500">PNG, JPG, SVG up to 2MB</p>
      </>
    ),
    uploading: (
      <>
        <FiLoader className="mx-auto h-12 w-12 text-indigo-500 animate-spin" />
        <p className="mt-2 text-sm text-gray-600">Uploading {fileName}...</p>
      </>
    ),
    success: (
      <>
        <FiCheckCircle className="mx-auto h-12 w-12 text-green-500" />
        <p className="mt-2 text-sm text-gray-600 truncate">Uploaded {fileName}</p>
      </>
    ),
    error: (
      <>
        <FiAlertCircle className="mx-auto h-12 w-12 text-red-500" />
        <p className="mt-2 text-sm text-red-600">Upload failed</p>
      </>
    ),
  };

  return (
    <div className="mt-1">
      <label
        htmlFor={`file-upload-${label.replace(/\s+/g, '-')}`}
        className="relative flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md cursor-pointer hover:border-indigo-400 transition-colors"
      >
        <div className="space-y-1 text-center">
            {statusContent[status]}
        </div>
        <input 
            id={`file-upload-${label.replace(/\s+/g, '-')}`} 
            name="file-upload" 
            type="file" 
            className="sr-only" 
            onChange={e => onFileSelect(e.target.files[0])}
            disabled={status === 'uploading'}
        />
      </label>
    </div>
  );
}

export default UploadField;